<template>
	<div id="page_title" class="nav vue-title" :mode="activeMode">
		<p class="vue-title__text" data-testid="title">
			{{ pageTitle }}
		</p>
		<i id="lockIcon" class="btn icon icon--small icon-lock" />
		<VueVersionSwitch
			:version="pageVersion"
			@startChange="onVersionChangeStart"
			@change="onVersionChange"
			:setPageVersion="setPageVersion"
			:popoverOptions="popoverOptions"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import VueVersionSwitch from './vue-ui-version-switch.vue';

export default {
	name: 'VueUiTitle',
	components: {
		VueVersionSwitch
	},
	data() {
		return {
			activeMode: 'light'
		};
	},
	props: {
		pageVersion: {
			type: Number,
			default: 1
		},
		setPageVersion: {
			type: Boolean,
			default: false
		},
		popoverOptions: {
			type: Object,
			default: () => {
				return {
					container: 'app',
					zIndex: 1000
				};
			}
		}
	},
	computed: {
		...mapGetters('user', ['pageTitle'])
	},
	methods: {
		onVersionChangeStart(version) {
			this.$emit('versionChangeStart', version);
		},
		onVersionChange(version) {
			this.$emit('versionChange', version);
		}
	}
};
</script>

<style lang="scss" scoped>
.vue-title {
	position: fixed;
	display: inline-flex;
	align-items: center;
	width: 100%;
	top: 48px;
	margin: 0;
	padding: $padding-sm $padding-md;
	background-color: var(--bg-0);
	color: var(--bg-0-fg-4);
	z-index: $z-level2;

	@include mq($from: md-l) {
		padding-left: 62px;
	}

	&__text {
		margin: 0;
		font-size: $page-title-font-size;
		font-weight: $page-title-font-weight;
		color: var(--nav-page-title);
	}
	i {
		display: none;
	}
}
</style>
